import { render, staticRenderFns } from "./CafeDesmatamentoSemAno.vue?vue&type=template&id=e7c0ea54&lang=pug"
import script from "./CafeDesmatamentoSemAno.vue?vue&type=script&lang=js"
export * from "./CafeDesmatamentoSemAno.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports